import type { IconProps } from "./icon-types";

/**
 * 플러스(add/create). "추가" 액션 버튼 등에서 공용.
 *
 * 24 그리드의 중앙에서 가로·세로 16 unit을 사용해 인접한 action glyph와 시각적 크기를 맞춘다.
 * 버튼의 공용 glyph 박스는 유지하고 artwork의 여백만 조정한다. strokeWidth 2 / round cap·join.
 */
export const PlusIcon = (props: IconProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    {...props}
  >
    <path d="M12 4v16M4 12h16" />
  </svg>
);
